import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceIdService {
  private readonly STORAGE_KEY = 'feather_device_id';

  /**
   * Get or create a unique device ID
   * Stores the ID in localStorage for persistence across sessions
   */
  getDeviceId(): string {
    const storedId = localStorage.getItem(this.STORAGE_KEY);
    
    if (storedId) {
      return storedId;
    }

    // Generate a new UUID
    const newId = this.generateUUID();
    localStorage.setItem(this.STORAGE_KEY, newId);
    
    return newId;
  }

  /**
   * Generate a UUID v4
   * Uses crypto.randomUUID() if available, otherwise falls back to manual generation
   */
  private generateUUID(): string {
    // Use crypto.randomUUID() if available (modern browsers)
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    // Fallback: manual UUID generation
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /**
   * Clear the device ID (useful for testing or reset scenarios)
   */
  clearDeviceId(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
